import {
  REQUEST_MAP_POSITIONS,
  RESPONSE_MAP_POSITIONS,
  REQUEST_MAP_POSITIONS_FAILURE,
  CLEAR_MAP_POSITIONS,
} from "../actions/mapPositionsActions";

import { states } from "./queriesStates";

const initialState = {
  dataState: states.NOT_REQUESTED,
  mapPositionsData: [],
  mapPositionsCount: 0,
  carNumber: 0,
  mapRoute: [],
  mapRoutes: [],
  mapPoints: [],
  dumpRoutes: [],
  dump2Routes: [],
  sandRoutes: [],
};

const mapPositionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_MAP_POSITIONS:
      return Object.assign({}, state, {
        dataState: states.REQUEST,
      });
    case RESPONSE_MAP_POSITIONS:
      const { mapPositionsData, mapPositionsCount, carNumber, mapRoute, mapRoutes, mapPoints, dumpRoutes, dump2Routes, sandRoutes } =
        action.payload;

      return Object.assign({}, state, {
        dataState: states.READY,
        mapPositionsData: mapPositionsData,
        mapPositionsCount: mapPositionsCount,
        carNumber: carNumber,
        mapRoute: mapRoute,
        mapRoutes: mapRoutes,
        mapPoints: mapPoints,
        dumpRoutes: dumpRoutes,
        dump2Routes: dump2Routes,
        sandRoutes: sandRoutes,
        errors: [],
      });
    case REQUEST_MAP_POSITIONS_FAILURE:
      return Object.assign({}, state, {
        dataState: states.FAILURE,
        errors: action.errors,
      });
    case CLEAR_MAP_POSITIONS:
      return Object.assign({}, state, initialState);
    default:
      return state;
  }
};

export default mapPositionsReducer;
